import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType } from '../../model';
import {
  IApiAddAdminRbacRoleBody,
  IApiAdminRbacRole,
  IApiDeleteAdminRbacRoleBody,
  IApiEditAdminRbacRoleBody,
  IApiEditAdminRbacRoleUsersBody,
  ISupportUserModel,
  ISupportUserModelCreate,
  RbacAdminPermObjectKey,
} from '../../model/api-modules';
import { ADMIN_RBAC_PROXY, ADMIN_SUPPORT_USER } from '../config';

export const getSupportUserPerm = (userId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_RBAC_PROXY}/GetUserPerm?permKey=adminAccount`;
      const response = await api.commonRequest('POST', url, {
        projectId: '0',
        userId,
      });
      const res = await parsedResponse<{
        projectPerm: readonly RbacAdminPermObjectKey[];
      }>(response, 'data');
      return res.projectPerm;
    } catch (error) {
      return false;
    }
  });

export const getSupportRoleList = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_RBAC_PROXY}/GetRoleList?permKey=${RbacAdminPermObjectKey.OrganizationRoleManage}`;
      const response = await api.commonRequest('POST', url, { projectId: '0' });
      const res = await parsedResponse<readonly IApiAdminRbacRole[]>(
        response,
        'data'
      );
      return res;
    } catch (error) {
      return false;
    }
  });

export const addSupportRole = (data: IApiAddAdminRbacRoleBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_RBAC_PROXY}/AddRole?permKey=adminAccount`;
      const response = await api.commonRequest('POST', url, data);
      await parsedResponse(response, 'data');
      return true;
    } catch (error) {
      return false;
    }
  });

export const editSupportRole = (data: IApiEditAdminRbacRoleBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_RBAC_PROXY}/ModifyRole?permKey=adminAccount`;
      const response = await api.commonRequest('POST', url, data);
      await parsedResponse(response, 'data');
      if (data.userList.length === 0) {
        const saveRes = await saveSupportRoleUsers({
          userIdList: [],
          operator: data.operator,
          roleId: data.roleId,
        });
        return saveRes;
      }
      return true;
    } catch (error) {
      return false;
    }
  });

export const saveSupportRoleUsers = (data: IApiEditAdminRbacRoleUsersBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_RBAC_PROXY}/SaveRoleUsers?permKey=${RbacAdminPermObjectKey.OrganizationRoleManage}`;
      await api.commonRequest('POST', url, {
        projectId: '0',
        ...data,
      });
      return true;
    } catch (error) {
      return false;
    }
  });

export const batchEditSupportRole = (data: IApiAdminRbacRole[]) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_RBAC_PROXY}/BatchModifyRole?permKey=adminAccount`;
      const response = await api.commonRequest('POST', url, { data });
      await parsedResponse(response, 'data');
      return true;
    } catch (error) {
      return false;
    }
  });

export const deleteSupportRole = (data: IApiDeleteAdminRbacRoleBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_RBAC_PROXY}/DeleteRole?permKey=adminAccount`;
      const response = await api.commonRequest('POST', url, data);
      await parsedResponse(response, 'data');
      return true;
    } catch (error) {
      return false;
    }
  });

export const getSupportUsers = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_SUPPORT_USER}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<readonly ISupportUserModel[]>(
        response,
        'data'
      );
      return res;
    } catch (error) {
      return false;
    }
  });

export const createSupportUsers = (users: ISupportUserModelCreate[]) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_SUPPORT_USER}`;
      const response = await api.commonRequest('POST', url, { users });
      await parsedResponse(response, 'data');
      return true;
    } catch (error) {
      return false;
    }
  });

export const deleteSupportUser = (id: number) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_SUPPORT_USER}/${id}`;
      const response = await api.commonRequest('DELETE', url);
      await parsedResponse(response, 'data');
      return true;
    } catch (error) {
      return false;
    }
  });
